import { ManageProductMemberGroupsButtonModalPreloadedQuery } from "@/product/member/admin/list/card/more-actions/manage-groups/__generated__/ManageProductMemberGroupsButtonModalPreloadedQuery.graphql"
import Relay from "@/relay/relayUtils"
import { DiscoButtonSkeleton } from "@disco-ui"
import {
  OverridableDiscoButton,
  OverridableDiscoButtonChildren,
} from "@disco-ui/button/OverridableDiscoButton"
import useDisclosure from "@utils/hook/useDisclosure"
import { useQueryLoader } from "react-relay"
import { graphql } from "relay-runtime"
import ManageProductMemberGroupsModal from "./ManageProductMemberGroupsModal"

interface ManageProductMemberGroupsButtonProps {
  refetchMemberships: () => void
  productMembershipId: string
  children: OverridableDiscoButtonChildren
}

export const ManageProductMemberGroupsButtonPreloadedQuery = graphql`
  query ManageProductMemberGroupsButtonModalPreloadedQuery($id: ID!) {
    node(id: $id) {
      __typename
      ... on ProductMembership {
        ...ManageProductMemberGroupsModalFragment @relay(mask: false)
      }
    }
  }
`

function ManageProductMemberGroupsButton({
  refetchMemberships,
  productMembershipId,
  children,
}: ManageProductMemberGroupsButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [queryReference, loadQuery] =
    useQueryLoader<ManageProductMemberGroupsButtonModalPreloadedQuery>(
      ManageProductMemberGroupsButtonPreloadedQuery
    )

  return (
    <>
      <OverridableDiscoButton onClick={onClick}>{children}</OverridableDiscoButton>
      {queryReference && (
        <ManageProductMemberGroupsModal
          isOpen={isOpen}
          onClose={onClose}
          refetchMemberships={refetchMemberships}
          productMembershipQueryRef={queryReference}
        />
      )}
    </>
  )

  function loadPreloadedQuery() {
    // Refetch the modal query on open
    // This ensures that the modal is getting the latest member groups data from services
    loadQuery({ id: productMembershipId })
  }

  function onClick() {
    loadPreloadedQuery()
    onOpen()
  }
}

export default Relay.withSkeleton({
  component: ManageProductMemberGroupsButton,
  skeleton: () => <DiscoButtonSkeleton />,
})
